<template>
  <div class="plan-upgrade-billing-details-component">
    <h2 class="text-sm font-semibold text-[#23569F] uppercase">{{ $t('planUpgrade.BillingDetails') }}</h2>
    <span class="hidden grid-cols-2 grid-cols-3 grid-cols-4 bg-blue-200 border-black border-[#23569F]"></span>
    <el-form
        ref="refFormBillingDetails"
        :model="model"
        :rules="modelRules"
        class="common-form mt-4">
      <el-row class="mt-6">
        <el-col :span="7" :offset="5">
          <h2 class="text-xs font-semibold text-[#23569F] uppercase ml-[-10px]">{{ $t('planUpgrade.CompanyInfo') }}</h2>
          <div class="grid-content w-[221px] mt-[8px]">
            <h2 class="text-xs font-semibold text-[#000000] block capitalize">*{{ $t("planUpgrade.companyName") }}</h2>
            <el-form-item prop="companyName" class="company-name">
              <el-input v-model="model.companyName"></el-input>
            </el-form-item>
          </div>

          <div class="grid-content w-[221px] mt-[12px]">
            <h2 class="text-xs font-semibold text-[#000000] block capitalize">{{ $t("planUpgrade.VATNumber") }}</h2>
            <el-form-item class="vat">
              <el-input v-model="model.VAT"></el-input>
            </el-form-item>
          </div>

          <div class="grid-content w-[221px] mt-[12px]">
            <h2 class="text-xs font-semibold text-[#000000] block normal-case">*{{ $t("label.streetAndNumber") }}</h2>
            <el-form-item prop="streetAndNumber" class="street-and-number">
              <el-input v-model="model.streetAndNumber"></el-input>
            </el-form-item>
          </div>

          <div class="grid grid-cols-2 w-[221px] mt-[12px]">
            <div class="w-[100px]">
              <h2 class="text-xs font-semibold text-[#000000] block capitalize">*{{ $t("label.city") }}</h2>
              <el-form-item prop="city" class="city">
                <SelectCity :cityName="model.city" @change="handleSelectCityChange"></SelectCity>
              </el-form-item>
            </div>
            <div class="w-[100px] ml-[11px]">
              <h2 class="text-xs font-semibold text-[#000000] block capitalize">*{{ $t("label.postalCode") }}</h2>
              <el-form-item prop="zip" class="zip flex justify-center w-full">
                <el-input v-model="model.zip"></el-input>
              </el-form-item>
            </div>
          </div>

          <div class="px-0 flex w-[221px] mt-[12px]">
            <country-flag :country="countryCode" size='normal' class="plan-upgrade-flag billing"/>
            <label class="text-xs mt-[0.6rem] ml-2">
              <span class="country-name block">{{countryName}}</span>
              <span v-if="state" class="state text-stone-400 block">{{handleer.getStateName(state)}}</span>
            </label>
          </div>
        </el-col>
        <el-col :span="7" :offset="1">
          <h2 class="text-xs font-semibold text-[#23569F] uppercase ml-[-10px]">{{ $t('planUpgrade.AccountOwner') }}</h2>

          <div class="grid-content w-[221px] mt-[8px]">
            <h2 class="text-xs font-semibold text-[#000000] block capitalize">*{{ $t("label.firstName") }}</h2>
            <el-form-item prop="firstName" class="firstname">
              <el-input v-model="model.firstName"></el-input>
            </el-form-item>
          </div>

          <div class="grid-content w-[221px] mt-[12px]">
            <h2 class="text-xs font-semibold text-[#000000] block capitalize">*{{ $t("label.lastName") }}</h2>
            <el-form-item prop="lastName" class="lastname">
              <el-input v-model="model.lastName"></el-input>
            </el-form-item>
          </div>

          <div class="grid-content w-[221px] mt-[12px]">
            <h2 class="text-xs font-semibold text-[#000000] block capitalize">*{{ $t("label.email") }}</h2>
            <el-form-item prop="email" class="email">
              <el-input v-model="model.email"></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script src="./plan-upgrade-billing-details.js"></script>
